import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TemaService } from '../../../../services/tema.service';
import { DarkModeService } from '../../../../services/dark-mode.service';
import { Subject, takeUntil, filter } from 'rxjs';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NavMenuComponent implements OnInit, OnDestroy {

  isExpanded = false;
  temas: any;

  private destroy$ = new Subject<void>();

  constructor(
    private temaService: TemaService,
    private router: Router,
    public darkModeService: DarkModeService
  ) {}

  ngOnInit() {

    // ✔️ carregar menu uma única vez
    this.temaService.getMenu()
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        this.temas = res;
      });

    // ✔️ fechar menu ao navegar
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter(ev => ev instanceof NavigationEnd)
      )
      .subscribe(() => {
        this.isExpanded = false;
      });
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  collapse() {
    this.isExpanded = false;
  }

  toggleDarkMode() {
    this.darkModeService.toggle();
    this.collapse(); // melhor UX: fecha menu ao trocar tema
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}